"use client";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/ui/link";
import { Instagram, Linkedin, Twitter } from "lucide-react";
import { TalentirLogo } from "../../components/theme/custom-svgs";
import { LottieVisible } from "../../components/ui/lottie-visible";

import type { JSX } from "react";

export function Footer(): JSX.Element {
    return (
        <footer className="mx-4 flex flex-col items-start pt-16">
            <LottieVisible className="h-[51px] w-[36px] py-3" src="/lottie/Main_zigzag02.json" />
            <div className="flex w-full flex-col justify-between py-10 md:flex-row md:pb-48">
                <div style={{ width: 180, marginBottom: 40 }}>
                    <TalentirLogo />
                </div>

                <div className="flex gap-3">
                    <Button size="icon" asChild className="size-11 rounded-full">
                        <a href="https://www.linkedin.com/company/talentir-com" target="_blank" rel="noreferrer">
                            <Linkedin />
                        </a>
                    </Button>
                    <Button size="icon" asChild className="size-11 rounded-full">
                        <a href="https://twitter.com/talentir_" target="_blank" rel="noreferrer">
                            <Twitter />
                        </a>
                    </Button>
                    <Button size="icon" asChild className="size-11 rounded-full">
                        <a href="https://instagram.com/talentir_official" target="_blank" rel="noreferrer">
                            <Instagram />
                        </a>
                    </Button>
                </div>
            </div>
            <div className="flex w-full flex-col justify-between py-4 md:flex-row">
                <p className="text-muted-foreground">© Talentir GmbH - All Rights Reserved</p>
                <div className="mt-4 flex flex-col gap-3 md:mt-auto md:flex-row">
                    <Link href="/legal/terms-and-conditions">Terms & Conditions</Link>
                    <span className="hidden md:visible">|</span>
                    <Link href="/legal/privacy-policy">Privacy Policy</Link>
                    <span className="hidden md:visible">|</span>
                    <Link href="/legal/legal-notice">Legal Notice</Link>
                    <span className="hidden md:visible">|</span>
                    <Link href="https://wa.me/41795381994" target="_blank">
                        Support
                    </Link>
                </div>
            </div>
        </footer>
    );
}
